import React, { Component } from 'react';

import classes from './WelcomeBanner.module.scss';
import Backdrop from '../Backdrop/Backdrop';

class WelcomeBanner extends Component {
    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.show !== this.props.show || 
            nextProps.children !== this.props.children;
    }

    render() {
        const appLayout = localStorage.getItem('app_layout') || 'ementas_digitais';

        return (
            <div className={classes[appLayout]}>
                <Backdrop show={this.props.show} clicked={this.props.bannerClosed} />
                <div className={classes.WelcomeBanner}
                    style={{
                        transform: this.props.show ? 'translateY(0)' : 'translateY(-100vh)',
                        opacity: this.props.show ? '1' : '0'
                    }}>
                    {this.props.children}
                </div>
            </div>
        );
    }
}

export default WelcomeBanner;